import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'reactstrap';
import * as Icon from 'react-feather';
import InputRecibo from '../InputRecibo';
import EstadoRecibo from '../EstadoRecibo';
import MetodosPago from '../MetodosPago';

function FilaRecibo({
  recibo: r,
  listadoRecibos,
  onReciboChange,
  setListadoRecibos,
  onFechaCobroChange,
  metodosPago,
  isLoadingMetodosPago,
  estados,
  isLoadingEstados,
  setRecibos,
  savingStatus,
  onSaveRecibo,
  onDownloadFile,
  onResendEmail,
  onCobrarManual,
  deshabilitarPorEmail,
  pasarelaLabel = 'Stripe',
}) {
  const [tooltipGuardar, setTooltipGuardar] = useState(false);
  const [tooltipRecibo, setTooltipRecibo] = useState(false);
  const [tooltipMail, setTooltipMail] = useState(false);
  const [tooltipCobrarManual, setTooltipCobrarManual] = useState(false);
  const isFacturado = r.Num_factura !== 'No facturado';
  const textClass = r.Estado === 'Cobrado' || isFacturado ? 'text-black-50' : '';
  const idGuardar = `guardarCambiosBtn-${r.NUM_Recibo}`;
  const idBajar = `bajarReciboBtn-${r.NUM_Recibo}`;
  const idMail = `enviarMailBtn-${r.NUM_Recibo}`;
  const idCobrarManual = `cobrarManualBtn-${r.NUM_Recibo}`;
  const isFormaRedsys = (r.Forma_de_pago || '').toUpperCase() === 'REDSYS';
  const netoCero = Number(r.Neto) === 0;
  const importeBloquea = netoCero && !isFormaRedsys;
  const yaCobrado = r.Estado === 'Cobrado';

  return (
    <tr key={r.codigo}>
      <td id={r.codigo} className={textClass}>
        <InputRecibo
          key={r.NUM_Recibo}
          id={r.NUM_Recibo}
          concepto={r.Concepto}
          neto={r.Neto}
          estado={r.Estado}
          onReciboChange={onReciboChange}
          listadoRecibos={listadoRecibos}
          setListadoRecibos={setListadoRecibos}
          disabled={isFacturado}
        />
      </td>
      <td className={textClass}>{r.Num_factura}</td>
      <td className={textClass}>{r.Concepto}</td>
      <td className={textClass}>{r.Fecha_Emision}</td>
      <td className={textClass}>{r.Fecha_vencimiento}</td>
      <td className={textClass}>
        {r.Estado === 'Cobrado' || isFacturado ? (
          r.Fecha_cobro
        ) : (
          <input
            type="date"
            className="form-control form-control-sm"
            value={
              r.Fecha_cobro
                ? new Date(r.Fecha_cobro).toLocaleDateString('en-CA')
                : ''
            }
            onChange={(e) => onFechaCobroChange(r.NUM_Recibo, e.target.value)}
            disabled={deshabilitarPorEmail}
          />
        )}
      </td>
      <td className={textClass}>{r.Neto}€</td>
      <td className={textClass}>{r.Bruto}€</td>
      <td className={textClass}>{r.descuento}%</td>
      <td className={textClass}>{r.Tipo_cliente}</td>
      <td>
        <MetodosPago
          numRecibo={r.NUM_Recibo}
          isLoading={isLoadingMetodosPago}
          actual={r.idPago}
          metodosPago={metodosPago}
          setRecibos={setRecibos}
          disabled={deshabilitarPorEmail}
        />
      </td>
      <td>
        <EstadoRecibo
          numRecibo={r.NUM_Recibo}
          isLoading={isLoadingEstados}
          actual={r.IdEstado}
          estados={estados}
          setRecibos={setRecibos}
          disabled={deshabilitarPorEmail}
        />
      </td>
      <td
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span id={idGuardar}>
          <Button
            size="sm"
            color={
              savingStatus[r.NUM_Recibo] === 'error'
                ? 'danger'
                : savingStatus[r.NUM_Recibo] === 'success'
                ? 'success'
                : 'success'
            }
            onClick={() => onSaveRecibo(r)}
            disabled={
              savingStatus[r.NUM_Recibo] === 'loading' || deshabilitarPorEmail || importeBloquea
            }
          >
            {savingStatus[r.NUM_Recibo] === 'loading' ? (
              <Icon.Loader
                size={20}
                color="#FFF"
                className="animate-spin align-text-center"
              />
            ) : savingStatus[r.NUM_Recibo] === 'success' ? (
              <Icon.Check size={20} color="#FFF" className="align-text-center" />
            ) : savingStatus[r.NUM_Recibo] === 'error' ? (
              <Icon.X size={20} color="#FFF" className="align-text-center" />
            ) : (
              <Icon.Save size={20} color="#FFF" className="align-text-center" />
            )}
          </Button>
        </span>
        <Tooltip
          placement="top"
          isOpen={tooltipGuardar}
          target={idGuardar}
          toggle={() => setTooltipGuardar(!tooltipGuardar)}
        >
          {importeBloquea ? 'Importe 0 solo permitido en Redsys' : 'Guardar cambios'}
        </Tooltip>
        <span id={idBajar}>
          <Button size="sm" onClick={() => onDownloadFile(r.NUM_Recibo)}>
            <Icon.Download size={20} className="align-text-center" />
          </Button>
        </span>
        <Tooltip
          placement="top"
          isOpen={tooltipRecibo}
          target={idBajar}
          toggle={() => setTooltipRecibo(!tooltipRecibo)}
        >
          Descargar recibo
        </Tooltip>
        <span id={idMail}>
          <Button
            size="sm"
            onClick={() => onResendEmail(r.NUM_Recibo)}
            disabled={
              deshabilitarPorEmail ||
              (!isFormaRedsys &&
                ((r.Estado === 'Cobrado' && r.Concepto === 'Inscripción matrícula') ||
                  r.Concepto.includes('Cuota')))
            }
          >
            <Icon.Mail size={20} className="align-text-center" />
          </Button>
        </span>
        <Tooltip
          placement="top"
          isOpen={tooltipMail}
          target={idMail}
          toggle={() => setTooltipMail(!tooltipMail)}
        >
          Enviar enlace de pago
        </Tooltip>
        <span id={idCobrarManual}>
          <Button
            size="sm"
            onClick={() => onCobrarManual(r.NUM_Recibo)}
            disabled={r.Forma_de_pago !== pasarelaLabel || deshabilitarPorEmail || yaCobrado}
          >
            <Icon.DollarSign size={20} className="align-text-center" />
          </Button>
        </span>
        <Tooltip
          placement="top"
          isOpen={tooltipCobrarManual}
          target={idCobrarManual}
          toggle={() => setTooltipCobrarManual(!tooltipCobrarManual)}
        >
          {yaCobrado
            ? 'Recibo ya cobrado'
            : isFormaRedsys
            ? 'Cobrar en Redsys'
            : 'Cobro manual STRIPE'}
        </Tooltip>
      </td>
    </tr>
  );
}

FilaRecibo.propTypes = {
  recibo: PropTypes.shape({
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    NUM_Recibo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Concepto: PropTypes.string,
    Neto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Estado: PropTypes.string,
    Num_factura: PropTypes.string,
    Fecha_Emision: PropTypes.string,
    Fecha_vencimiento: PropTypes.string,
    Fecha_cobro: PropTypes.string,
    Bruto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    descuento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Tipo_cliente: PropTypes.string,
    idPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    IdEstado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Forma_de_pago: PropTypes.string,
  }).isRequired,
  listadoRecibos: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  onReciboChange: PropTypes.func.isRequired,
  setListadoRecibos: PropTypes.func.isRequired,
  onFechaCobroChange: PropTypes.func.isRequired,
  metodosPago: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoadingMetodosPago: PropTypes.bool.isRequired,
  estados: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoadingEstados: PropTypes.bool.isRequired,
  setRecibos: PropTypes.func.isRequired,
  savingStatus: PropTypes.objectOf(PropTypes.string).isRequired,
  onSaveRecibo: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onResendEmail: PropTypes.func.isRequired,
  onCobrarManual: PropTypes.func.isRequired,
  deshabilitarPorEmail: PropTypes.bool.isRequired,
  pasarelaLabel: PropTypes.string,
};

export default FilaRecibo;
